import { DateRage } from "components/HeroSearchForm2/FlightSearchForm";
import React, { createContext, useState, useContext, Dispatch, SetStateAction } from "react";

export interface GlobalStateInterface {
    location: string;
    dateRange: DateRage;
    guests: {
        adults: number | undefined;
        children: number | undefined;
        infants: number | undefined;
    }
  }

const GlobalSearchContext = createContext({
    state: {} as Partial<GlobalStateInterface>,
    setState: {} as Dispatch<SetStateAction<Partial<GlobalStateInterface>>>,
  });

const GlobalStateProvider = ({
    children,
    value = {} as GlobalStateInterface,
  }: {
    children: React.ReactNode;
    value?: Partial<GlobalStateInterface>;
  }) => {
    const [state, setState] = useState(value);
    return (
      <GlobalSearchContext.Provider value={{ state, setState }}>
        {children}
      </GlobalSearchContext.Provider>
    );
  };

  const useGlobalState = () => {
    const context = useContext(GlobalSearchContext);
    if (!context) {
      throw new Error("useGlobalState must be used within a GlobalStateContext");
    }
    return context;
  };
  
  export { GlobalStateProvider, useGlobalState };